<div class="template-form">
  <div id="booking-info">
    <div class="col-md srch-area" id="booking-search-area">
      <search-transaction-booking id="booking-search-data" [data]="flag" (selectedBooking)="getSelectedBookingInfo($event)"></search-transaction-booking>
      <app-transaction-booking-viewer id="booking-viewer-data" [data]="bookingData"></app-transaction-booking-viewer>
    </div>
  </div>
</div>

